import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectRegistrationNumber, selectVatnumber, selectShowInvalids } from '@store/partners-registration/selectors';
import { setRegistrationNumber, setVatnumber } from '@store/partners-registration/slice';
import TextField from '@components/text-field/TextField';
import { invalidFormValue } from '@components/utils';



const CompanyInfo = () => {
	const { t } = useTranslation('forms');

	const registrationNumber = useSelector(selectRegistrationNumber);
	const vatNumber = useSelector(selectVatnumber);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateRegistrationNumber = (value: string | null) => dispatch(setRegistrationNumber(value));
	const updateVatNumber = (value: string | null) => dispatch(setVatnumber(value));

	return (
		<div className='company-info-section'>

			{process.env.SHOW_COMPANY_REGISTRATION_ID === 'TRUE' &&
				<TextField
					label={t('inputLabels.companyId')}
					required={true}
					value={registrationNumber ? registrationNumber : undefined}
					rounded={true}
					maxLength={8}
					onChange={(value: string) =>
						!value && value.length === 0 ? updateRegistrationNumber(null) : updateRegistrationNumber(value)}
					errorMessage={showInvalids && invalidFormValue(registrationNumber) ? t('validation.requiredField') : undefined} />
			}

			<TextField
				label={t('inputLabels.taxId')}
				required={true}
				value={vatNumber ? vatNumber : undefined}
				rounded={true}
				maxLength={10}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateVatNumber(null) : updateVatNumber(value)}
				errorMessage={showInvalids && invalidFormValue(vatNumber) ? t('validation.requiredField') : undefined} />

		</div>
	);
};

export default CompanyInfo;